import {RankedSeasonState} from '../../../../shared/ranked/ranked_season_data/RankedSeasonState'

export class UILeaderboardSeasonProgressController {
    readonly seasonProgressDates: HTMLSpanElement
    readonly seasonProgressBar: HTMLDivElement

    constructor(liveSeasonData: RankedSeasonState) {
        this.seasonProgressDates = document.getElementById('progress_dates') as HTMLSpanElement
        this.seasonProgressBar = document.querySelector<HTMLDivElement>('.leaderboard_season_progress_bar') as HTMLDivElement

        const timing = liveSeasonData.getCurrentSeasonTiming(new Date())

        this.seasonProgressDates.innerText = RankedSeasonState.getShowingTimeLeftUntilSeasonEndText(timing)
        this.seasonProgressBar.style.width = `${timing.progress * 100}%`
    }
}
